export default __webpack_public_path__ + "static/media/transfer-epoint-step3.08de0fe9.png";